import smoothScroll from '../../plugins/smooth-scroll.js';

// 外部リンクとページ内リンクを分離して処理
$("a[href*='#']").each(function() {
  const href = $(this).attr('href');
  
  // 処理対象外のリンクはスキップ
  if (!href || 
      href === "#" || 
      href.includes('#subcategoryid') || 
      href.includes('#pageno')) {
    return;
  }

  // 外部リンクかどうかを判定
  const isExternalLink = href.indexOf('http') === 0 || href.indexOf('//') === 0;
  
  if (isExternalLink) {
    // 外部リンクの場合はdata-scrollを付けない
    $(this).addClass('external-link');
  } else {
    // ページ内リンクの場合
    const id = href.substring(href.indexOf("#"));
    if ($(id).length) {
      $(this).attr('data-scroll', '');
    }
  }
});

// スムーズスクロールの初期化
// external-linkクラスを持つものは対象外に
smoothScroll.init({
  speed: 800,
  offset: $(window).width() >= 1024 ? 115 : 0,
  ignore: '.external-link' // 外部リンクを無視
});